
import { Env } from '@stencil/core';
import { BIN_API, getFeedbackData, handlePSonLoad, sendFeedback } from '../../../../common/hair-quiz-vto/handlers/result.handlers';

let analyticsService = null;

export const handleRecommendedProductsOnLoad = async data => {
    if (window['AIBA'] && window['AIBA']['utils']) {
      const handlers = window['AIBA']['utils'];
      let responseWithSections = await handlers.getRecommendedProductsFromState();
  
      const finalProList = await responseWithSections.map(item => {
        item?.variants?.map(variant => {
          if (variant?.price) {
            if (variant?.compare_at_price) {
              let discountPrice = variant?.compare_at_price - variant.price;
              let discountPercent = Math.round((discountPrice / variant.compare_at_price) * 100);
              variant['discountPercent'] = `${discountPercent}% OFF`;
              const priceElement = `<span class="discount-price">₹${variant.price}</span><span class="actual-price">₹${variant?.compare_at_price}</span><span class="discount-percentage">${variant?.discountPercent}</span>`;
              variant['priceToDisplay'] = priceElement;
            } else {
              const priceElement = `<span class="discount-price">₹${variant.price}</span>`;
              variant['priceToDisplay'] = priceElement;
            }
  
            return variant;
          }
        });
        return item;
      });
  
      finalProList.map(item => {
        item.shortDescription = item.description;
        item?.variants?.map(variant_data => {
          if (variant_data?.inventory_quantity === 0) {
            variant_data.disabled = true;
            item.disabled = true;
          }
        });
      });
  
      data['list'] = finalProList;
      //binInit for PS
  
      const config = await handlers.getConfig();
      const buyItNow: any = config.buyItNow;
  
      if (buyItNow.api === BIN_API.PRICESPIDER) {
        handlePSonLoad(data['list'], buyItNow.api);
        const bin = await handlers.binService.getBinApi(buyItNow.api);
  
        const args = {
          ps_key: Env.API_KEY_PRICE_SPIDER,
          ps_language: buyItNow[buyItNow.api].language,
          ps_country: buyItNow[buyItNow.api].country,
          ps_url: buyItNow[buyItNow.api].url,
          ps_trackUrl: buyItNow[buyItNow.api].trackUrl,
          ps_versionUrl: buyItNow[buyItNow.api].versionUrl,
        };
  
        await bin.binInit(...Object.values(args));
      }
  
      if (buyItNow.api === BIN_API.MIKMAK) {
        let mikMakElement, binInitElement;
        binInitElement = data['elements'].find(item => item.name === 'aiba-bin-init');
        if (binInitElement) {
          mikMakElement = binInitElement.data.product.data['elements'].find(item => item.name === 'aiba-mik-mak');
        }
  
        if (mikMakElement) {
          let appId = Env[buyItNow[buyItNow.api].appId];
          mikMakElement['data'] = {
            ...buyItNow[buyItNow.api],
            appId,
          };
        }
      }
  
      analyticsService = handlers.analyticsService;
  
      await analyticsService?.registerEvent('event1', { page: 'vto recommended product screen' });
  
      const customResultsEvent = {};
      customResultsEvent['data'] = [];
      customResultsEvent['label'] = 'AIBA - Beauty Advisor completed';
      customResultsEvent['component'] = 'Beauty Advisor';
      let quizInfo = '';
      const retake = await handlers.getStateRetakeJourney();
      
      quizInfo = `hair analysis - ${retake ? 'retake' : 'take'} quiz`;
      customResultsEvent['data']['quizInfo'] = quizInfo;
      analyticsService.registerEvent('event25', customResultsEvent);
  
      const customProductsEvent = {};
      customProductsEvent['data'] = data['list'];
      await analyticsService?.registerEvent('event11', customProductsEvent);
      const feedbackBaseData = await getFeedbackData();
      sendFeedback(feedbackBaseData);
      return data;
    }
  };

  export const newsletterlinkhandler = async (event: Event) => {
    if (window['AIBA'] && window['AIBA']['utils']) {
        const handlers = window['AIBA']['utils'];
        analyticsService = handlers.analyticsService;
        analyticsService?.registerEvent('event2', event);
    }
  }

  export const handleShareButtonClick = async (event, data) => {
    if (window['AIBA'] && window['AIBA']['utils']) {
      const handlers = window['AIBA']['utils'];
      analyticsService = handlers.analyticsService;
      window.open(data.pageUrl);
      event['data'] = data;
      event.target['dataset']['product'] = JSON.stringify(data);
      await analyticsService?.registerEvent('event12', event);
    }
  };